import { c as _c } from "react/compiler-runtime";
import { cn } from '../../../../../../shared/cn';
import { P2 } from '../../../../../typography/Paragraph';
type MarkdownRenderCompileTimeErrorProps = {
  description?: string;
  message: string;
  className?: string;
};
export function MarkdownRenderCompileTimeError(t0) {
  const $ = _c(10);
  const {
    description: t1,
    message,
    className
  } = t0;
  const description = t1 === undefined ? "Nie uda\u0142o si\u0119 wy\u015Bwietli\u0107 tre\u015Bci. Sprawd\u017A poprawno\u015B\u0107 sk\u0142adni lub komponent\xF3w." : t1;
  let t2;
  if ($[0] !== className) {
    t2 = cn("custom-scrollbar text-contentSecondary", className);
    $[0] = className;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <br />;
    t4 = <br />;
    $[2] = t3;
    $[3] = t4;
  } else {
    t3 = $[2];
    t4 = $[3];
  }
  let t5;
  if ($[4] !== description || $[5] !== message) {
    t5 = <P2 className="text-contentRed">{description}{t3}{t4}{message}</P2>;
    $[4] = description;
    $[5] = message;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t2 || $[8] !== t5) {
    t6 = <div className={t2}>{t5}</div>;
    $[7] = t2;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  return t6;
}